import { useMemo } from 'react';
import { z } from 'zod';

import { getMetaField } from '../meta-field';
import { validationErrors } from '../validation-errors';

import { PASS_PATTERN } from './helper';

const { getNumberLatinFormatMessage, getLengthMessage, getInvalidConfirmPass } = validationErrors;

export const useValidationResetPass = () => {
	const metaField = useMemo(() => getMetaField(), []);

	const resetPassSchema = z
		.object({
			token: z.string(),
			password: z
				.string()
				.trim()
				.min(8, getLengthMessage(metaField.password.label, 8))
				.regex(new RegExp(PASS_PATTERN), getNumberLatinFormatMessage(metaField.password.label)),
			confirm: z
				.string()
				.trim()
				.min(8, getLengthMessage(metaField.password.label, 8))
				.regex(new RegExp(PASS_PATTERN), getNumberLatinFormatMessage(metaField.password.label)),
		})
		.refine((data) => data.password === data.confirm, {
			message: getInvalidConfirmPass(),
			path: ['confirm'],
		});
	return { resetPassSchema };
};

export type ResetPass = z.infer<ReturnType<typeof useValidationResetPass>['resetPassSchema']>;
